import Cookies from 'js-cookie';

const supportedOfflineConversionParams = ['gclid', 'wbraid'];
const saveOfflineConversionToCookies = (cookieSettings) => {
    const queryParams = new URLSearchParams(window.location.search);
    let isSupportedOfflineConversionParamsInURL = false;
    // Detect if any offline conversion param exist in the URL
    queryParams.forEach((value, param) => {
        if (supportedOfflineConversionParams.includes(param)) {
            isSupportedOfflineConversionParamsInURL = true;
        }
    });
    // Remove all offline conversion related Cookies if URL contains offline conversion params
    if (isSupportedOfflineConversionParamsInURL) {
        supportedOfflineConversionParams.forEach((param) => {
            Cookies.remove(param, cookieSettings);
        });
    }
    // Set offline conversion params in cookies
    queryParams.forEach((value, param) => {
        if (supportedOfflineConversionParams.includes(param)) {
            Cookies.set(param, value, cookieSettings);
        }
    });
};
const getOfflineConversion = () => {
    let hasOfflineConversion = false;
    const offlineConversion = {};
    // Then get them
    supportedOfflineConversionParams.forEach((param) => {
        if (Cookies.get(param)) {
            hasOfflineConversion = true;
            offlineConversion[param] = Cookies.get(param);
        }
    });
    return hasOfflineConversion ? offlineConversion : undefined;
};

export { getOfflineConversion, saveOfflineConversionToCookies, supportedOfflineConversionParams };
